import instanceCommerce from "../config/instanceCommerce.js";

export const LoginUser = async (id, pwd, profile) => {
  try {
    const body = new FormData();
    body.append("nro_comercio", id);
    body.append("password", pwd);
    body.append("rol", profile);
    const data = await instanceCommerce({
      url: `/api/logincomercios`,
      data: body,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((res) => {
      return res.data;
    });
    return data;
  } catch (error) {
    console.error("ERROR: ", error)
  }
};

export const CommerceInfo = async (dataCommerce, token) => {
  try {
    const data = await instanceCommerce({
      url: `/api/GetShop?nro_comercio=${dataCommerce}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    }).then((res) => {
      return res.data;
    });
    return data;
  } catch (error) {
    return false;
  }
};

export const UserActivityDay = async (id, token, commerce) => {
  const url = `/api/GetActivityDay?dni_suscriptor=${id}&nro_comercio=${commerce}`;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const { data } = await instanceCommerce(url, config);
    return data;
  } catch (error) {
    return { success: false, msg: error.response.data.error };
  }
};

export const registerCollaborator = async ({dni, name, email, pwd, token}) => {
  try {
    const body = new FormData();
    body.append("nro_documento", dni);
    body.append("nombre_completo", name);
    body.append("password", pwd);
    body.append("email", email);
    const data = await instanceCommerce({
      url: `/api/crear-colaborador`,
      data: body,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      return res.data;
    });
    return data;
  } catch (error) {
    console.log("Error:", error);
    throw error.response?.data || error;
  }
};
export const updateUser = async (id, token, email) => {
  try {
    const body = new FormData();
    body.append("email", email);
    const data = await instanceCommerce({
      url: `/api/users/${id}`,
      data: body,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      return res.data;
    });
    return data;
  } catch (error) {
    return false;
  }
};
